// angular
//     .module("HeroPRO")
//     .controller("UploadModalController", uploadModalController);

import _ from 'lodash';
import './uploadModal.scss';

/* @ngInject */
export default function uploadModalController($scope, documentInfo, FRInformationFactory, FRClosingFactory, raSpinnerService, $rootScope, $state, $stateParams, $analytics, HPPipelineStages, HPConditionTypes) {
    const vm = this;
    let paymentInstructionsConfirmed = false;
    vm.fileUploaded = false;
    vm.attachmendId = null;
    vm.conditionIds = [];
    vm.isGlobalFileUpload = false;
    vm.designatingDocuments = false;
    vm.designationError = false;
    vm.originalFilename = '';
    vm.documentHelperSteps = [];
    vm.designationOptions = [];
    vm.optionsByConditionType = {};
    vm.toggleDesignationOption = toggleDesignationOption;
    vm.conditionTypeName = documentInfo !== undefined ? documentInfo.ConditionTypeDetail.Name : '';
    vm.conditionTypeId = documentInfo !== undefined ? documentInfo.ConditionTypeDetail.ConditionTypeId : '';
    vm.showPDFPreviewError = false;
    vm.fundingRequest = {};
    vm.currentPipelineStageName = '';
    vm.tempFileKey = '';
    vm.hasHIC = false;
    vm.HPConditionTypes = HPConditionTypes;

    init();

    function init() {
    // Listen for the completion of the file upload
        $scope.$on('HPFileUploaded', (event, args, file) => {
            fileUploadComplete(args, file);
        });

        FRClosingFactory.getFundingRequestClosingPromise().then(() => {
            vm.fundingRequest = FRClosingFactory.getFundingRequest();
            paymentInstructionsConfirmed = FRClosingFactory.getPaymentInstructionsConfirmed();
            vm.currentPipelineStageName = _.find(HPPipelineStages, pipelineStage => pipelineStage.pipelineStageId === FRInformationFactory.getStateMachineData().PipelineStageId).name;

            if (documentInfo !== undefined) {
                // Uploading a specific document type
                vm.isGlobalFileUpload = false;
                processUploadByDocumentType();
                groupdDesignationOptionsByConditionType();

                // Set the document that was clicked on as designated
                toggleDesignationOption({
                    conditionId: documentInfo.ConditionId,
                    conditionTypeId: documentInfo.ConditionTypeDetail.ConditionTypeId,
                    selected: true,
                    label: documentInfo.Description,
                });
            } else {
                // Global document upload
                vm.isGlobalFileUpload = true;
                processGlobalUpload();
                groupdDesignationOptionsByConditionType();
            }
        });
    }

    function processUploadByDocumentType() {
        _.each(vm.fundingRequest.ConditionDetails, (condition) => {
            if (condition.ConditionTypeDetail.ConditionTypeId === documentInfo.ConditionTypeDetail.ConditionTypeId) {
                const productName = !!condition.ConditionImprovementDetail ? condition.ConditionImprovementDetail.EETypeDetail.Name : '';
                const selected = condition.ConditionId === documentInfo.ConditionId;

                addDesignationOption(false, condition.ConditionId, condition.ConditionTypeDetail.ConditionTypeId, selected, condition.ConditionTypeDetail.Name, productName);
            }
        });
    }

    function processGlobalUpload() {
        _.each(vm.fundingRequest.ConditionDetails, (condition) => {
            const productName = !!condition.ConditionImprovementDetail ? condition.ConditionImprovementDetail.EETypeDetail.Name : '';
            addDesignationOption(true, condition.ConditionId, condition.ConditionTypeDetail.ConditionTypeId, false, condition.ConditionTypeDetail.Name, productName);
        });
    }

    function groupdDesignationOptionsByConditionType() {
        let showDocumentDesignation;

        // Find if there's an HIC condition
        vm.hasHIC = _.findWhere(vm.designationOptions, { conditionTypeId: HPConditionTypes.HIC }) !== undefined;

        vm.optionsByConditionType = _.groupBy(vm.designationOptions, option => option.conditionTypeId);

        if (_.keys(vm.optionsByConditionType).length > 1) {
            showDocumentDesignation = true;
        } else {
            // Determine if we need to add document designation as the first helper screen
            showDocumentDesignation = _.find(vm.optionsByConditionType, option => option.length >= 1);
        }

        if (showDocumentDesignation !== undefined && documentInfo === undefined) {
            vm.documentHelperSteps.unshift({
                conditionTypeId: 0,
                template: 'app/appDetail/documents/uploadDocumentsModal/documentDesignation.html',
            });
        }
    }

    function fileUploadComplete(args, file) {
        vm.tempFileKey = file.tempFileKey;
        vm.originalFilename = file.name;

        $scope.$apply(() => {
            vm.fileUploaded = true;
        });
    }

    function addDesignationOption(globalUpload, conditionId, conditionTypeId, selected, documentName, productName) {
    // Extra check to determine whether Completion Certificate or Final Invoice should be shown as an upload option
    // Also do not show Completion Certificate if the user does not have elevated access
        if (((conditionTypeId === HPConditionTypes.CompletionCertificate ||
             conditionTypeId === HPConditionTypes.Invoice ||
             conditionTypeId === HPConditionTypes.HIC) && paymentInstructionsConfirmed === false) ||
            (conditionTypeId === HPConditionTypes.CompletionCertificate && $scope.main.userData.HasElevatedAccess === undefined)) {
            return;
        }

        const designationOption = {
            conditionId,
            conditionTypeId,
            selected,
            label: (globalUpload === true) ? (documentName + (productName !== '' ? ` for ${productName}` : '')) : productName,
        };

        vm.designationOptions.push(designationOption);
    }

    function updateDocumentHelperSteps(toggledOption) {
    // Trying to add new helper step
        if (toggledOption.selected === true) {
            const exists = _.find(vm.documentHelperSteps, helperStep => helperStep.conditionTypeId === toggledOption.conditionTypeId);

            if (exists === undefined) {
                addDocumentHelperStep(toggledOption);
            }
        }
        //
        // Trying to remove an existing helper step
        if (toggledOption.selected === false) {
            let numSelectedDocuments = 0;
            _.each(vm.optionsByConditionType[toggledOption.conditionTypeId], (option) => {
                if (option.selected === true) {
                    numSelectedDocuments++;
                }
            });

            if (numSelectedDocuments === 0) {
                removeDocumentHelperStep(toggledOption);
            }
        }
    }

    function addDocumentHelperStep(toggledOption) {
        switch (toggledOption.conditionTypeId) {
        case HPConditionTypes.CompletionCertificate:
            vm.documentHelperSteps.push({
                conditionTypeId: toggledOption.conditionTypeId,
                template: 'app/appDetail/documents/uploadDocumentsModal/completionCertificateChecklistTemplate.html',
            });
            break;
        case HPConditionTypes.Invoice:
            vm.documentHelperSteps.push({
                conditionTypeId: toggledOption.conditionTypeId,
                template: 'app/appDetail/documents/uploadDocumentsModal/invoiceChecklistTemplate.html',
            });
            break;
        case HPConditionTypes.InitialBuildingPermitPaperwork:
        case HPConditionTypes.ProofFinalPermitInspection:
        case HPConditionTypes.ProofInitialFinalPermit:
            vm.documentHelperSteps.push({
                conditionTypeId: toggledOption.conditionTypeId,
                template: 'app/appDetail/documents/uploadDocumentsModal/permitChecklistTemplate.html',
            });
            break;
        case HPConditionTypes.SolarLeasePPAAgreement:
            vm.documentHelperSteps.push({
                conditionTypeId: toggledOption.conditionTypeId,
                template: 'app/appDetail/documents/uploadDocumentsModal/solarLeaseAgreementChecklistTemplate.html',
            });
            break;
        case HPConditionTypes.HIC:
            vm.documentHelperSteps.push({
                conditionTypeId: toggledOption.conditionTypeId,
                template: 'app/appDetail/documents/uploadDocumentsModal/hicChecklistTemplate.html',
            });
            break;
        }
    }

    function removeDocumentHelperStep(toggledOption) {
        _.find(vm.documentHelperSteps, (step, index) => {
            if (step.conditionTypeId === toggledOption.conditionTypeId) {
                vm.documentHelperSteps.splice(index, 1);
                return true;
            }
        });
    }

    function toggleConditionSatisfied(conditionId) {
        if (_.contains(vm.conditionIds, conditionId)) {
            // Remove an existing conditionId
            vm.conditionIds = _.without(vm.conditionIds, conditionId);
        } else {
            // Add a new conditionId
            vm.conditionIds.push(conditionId);
        }
    }

    function toggleDesignationOption(toggledOption) {
        toggleConditionSatisfied(toggledOption.conditionId);
        updateDocumentHelperSteps(toggledOption);
    }

    vm.handlePrimaryButtonClick = () => {
        if (vm.documentHelperSteps.length === 1 && vm.conditionIds.length !== 0) {
            vm.finishUpload();
        } else {
            // Show the next step
            vm.documentHelperSteps.shift();
        }
    };

    vm.getPrimaryButtonText = () => {
        if (vm.documentHelperSteps.length === 1 && vm.conditionIds.length !== 0) {
            return 'Finish Upload';
        }

        return 'Next';
    };

    vm.getCurrentHelperStep = () => { 
        if(!!vm.documentHelperSteps && vm.documentHelperSteps.length > 0 && vm.documentHelperSteps[0].template) {
            return vm.documentHelperSteps[0].template;
        }
    }

    vm.closeModal = () => {
        $scope.$close();
        raSpinnerService._unregister('documentUploadSpinner');
    };

    vm.finishUpload = () => {
        let eventName = (vm.conditionTypeName === '') ? 'Global Upload' : vm.conditionTypeName;
        eventName = `${vm.currentPipelineStageName} ${eventName}`;
        $analytics.eventTrack('Upload Project Docs', { category: 'DocsModule', label: eventName });

        vm.designatingDocuments = true;
        raSpinnerService.show('documentUploadSpinner');

        let requestTask = null;
        const params = {
            ConditionIds: vm.conditionIds,
        };

        params.TempFileKey = vm.tempFileKey;
        params.FileName = vm.originalFilename;
        params.HEROId = vm.fundingRequest.FundingRequestDetail.HEROId;
        params.LoanId = vm.fundingRequest.FundingRequestDetail.LoanId;
        params.FundingRequestId = vm.fundingRequest.FundingRequestDetail.FundingRequestId;
        params.ContractorId = vm.fundingRequest.FundingRequestDetail.ContractorId;

        if (vm.conditionIds.length) {
            // Grab the first conditionId in the list and find the corresponding ConditionDetail item
            const conditionDetail = _.find(vm.fundingRequest.ConditionDetails, cd => cd.ConditionId === vm.conditionIds[0]);
            params.DMAttachmentTypeId = conditionDetail.ConditionTypeDetail.DMAttachmentTypeId;
        }

        requestTask = FRClosingFactory.commitAttachment(params);

        requestTask.then((response) => {
            raSpinnerService.hide('documentUploadSpinner');
            vm.designatingDocuments = false;
            if (response.data.ResultText === 'Success') {
                vm.closeModal();
            } else {
                vm.designationError = true;
            }
            // TODO: temporarily refreshing route while we can get the new Loan anc CC state from the assignAttachmentToConditions function
            $state.go($state.current, $stateParams, { reload: true, inherit: false });
        });
    };

    $rootScope.$on('PDFPreviewError', () => {
        vm.showPDFPreviewError = true;
        $scope.$apply();
    });
}



// WEBPACK FOOTER //
// ./src/app/appDetail/documents/uploadDocumentsModal/uploadModalController.js